<div class="auth">
  <mat-card class="auth-card" appearance="outlined">
    <div class="back-link">
      <a routerLink="/" class="back-button">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" fill="currentColor"/>
        </svg>
        Back to Sign in
      </a>
    </div>

    <div class="brand">
      <img class="logo" src="assets/white-green.png" alt="Visual Price Estimator logo" />
      <h1>Visual Price Estimator</h1>
      <p class="subtitle">Request access to continue</p>
    </div>

    <form class="form" [formGroup]="accessForm" (ngSubmit)="requestAccess()" novalidate>
      <mat-form-field appearance="outline" class="full">
        <mat-label>Email</mat-label>
        <input matInput type="email" placeholder="you@company.com" formControlName="email" autocomplete="email" required />
        <mat-error *ngIf="accessForm.get('email')?.hasError('required')">Email is required.</mat-error>
        <mat-error *ngIf="accessForm.get('email')?.hasError('email') && !accessForm.get('email')?.hasError('required')">Enter a valid email.</mat-error>
      </mat-form-field>

      <button class="full cta" mat-raised-button color="primary" type="submit" [disabled]="accessForm.invalid">
        Request Access
      </button>

      <div class="server-message" *ngIf="showSuccessText" role="alert" aria-live="polite">{{ infoText }}</div>
    </form>
  </mat-card>
</div>
